import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl = environment.serverUrl + 'customers';
  constructor(private http: HttpClient) {}

  login(login: any): Observable<Object> {
    return this.http.post(`${environment.serverUrl}login/admin`, {
      email: login.Email,
      password: login.Password,
    });
  }

  userList(
    page: number,
    size: number,
    search: string = '',
    startDate,
    endDate
  ): Observable<any> {
    const data = {
      page: page,
      size: size,
      search: search,
      startDate: startDate,
      endDate: endDate,
    };
    return this.http.post(`${this.baseUrl}`, data);
  }

  getUserDetailsById(Id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/${Id}`);
  }

  changeUserStatus(id, status): Observable<any> {
    const userId = id;
    const IsActive = status;
    return this.http.get(
      `${this.baseUrl}/change-status/${userId}?IsActive=${IsActive}`
    );
  }

  createAdmin(id): Observable<any> {
    const userId = id;
    return this.http.get(`${this.baseUrl}/create-admin/${userId}`);
  }

  changeAccountType(id, status): Observable<any> {
    const userId = id;
    const type = status;
    return this.http.get(
      `${this.baseUrl}/change-user-type/${userId}?type=${type}`
    );
  }

  suspendUser(id, status): Observable<any> {
    const userId = id;
    const IsSuspended = status;
    return this.http.get(
      `${this.baseUrl}/suspend-user/${userId}?IsSuspended=${IsSuspended}`
    );
  }

  activateMedia(id, status): Observable<any> {
    const userId = id;
    const IsSuspended = status;
    return this.http.get(
      `${this.baseUrl}/activate-media/${userId}?MediaApproved=${IsSuspended}`
    );
  }

  deleteUser(id): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  getUserList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/get`);
  }

  getProfileList(searchText: string = ''): Observable<object> {
    return this.http.get(
      `${this.baseUrl}/search-user?searchText=${searchText}`
    );
  }

  getCountriesData(): Observable<{ country_code: string; country: string }[]> {
    return this.http.get<{ country_code: string; country: string }[]>(
      `${this.baseUrl}/countries`
    );
  }

  getZipData(zip: string, country: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/zip/${zip}?country=${country}`);
  }

  updateProfile(id, customer): Observable<Object> {
    return this.http.put(`${this.baseUrl}/profile/${id}`, customer);
  }

  getUserEmailList(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/get-emails`, data);
  }

  deleteAllData(id): Observable<any> {
    return this.http.delete(`${this.baseUrl}/delete-all/${id}`);
  }

  updatePassword(currentPassword: string, newPassword: string): Observable<any> {
    const data = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    };
    const url = `${this.baseUrl}/update-password`;
    return this.http.put(url, data);
  }

   resendActivationEmail(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/resend-activation-email/${id}`);
  }
}
